<template>
  <div>
    <v-tooltip open-delay="500" top>
      <template #activator="{on, attrs}">
        <v-btn x-small icon v-bind="attrs" v-on="on" @click="dialog_ativo = true">
          <v-icon small v-text="'mdi-information-outline'" />
        </v-btn>
      </template>
      <span>Mais detalhes</span>
    </v-tooltip>

    <v-dialog
      v-model="dialog_ativo"
      fullscreen
      transition="dialog-bottom-transition"
    >
      <v-card-title class="text-white px-2" style="background: #042333;">
        <v-btn icon dark class="mr-5">
          <v-icon @click="dialog_ativo = false">mdi-close</v-icon>
        </v-btn>

        <span>Características da categoria</span>
      </v-card-title>

      <v-card-text class="bg-white px-2" style="height: calc(100vh - 90px)">
        <slot name="prepend-card-text" />

        <table class="w-full mt-2">
          <tr v-for="(linha, index) in linhas" :key="index">
            <td
              v-for="(coluna, _index) in linha.colunas"
              :key="`${index}-${_index}`"
              :colspan="coluna.colspan || 1"
              :style="coluna.style || ''"
            >
              <p class="font-weight-medium" v-text="coluna.descricao" />

              <div class="d-flex">
                <template v-if="coluna.numero">
                  <p v-text="Helpers.formatarValor(caracteristicas[coluna.valor] || 0)" />
                </template>
                <template v-else-if="coluna.dinheiro">
                  <p v-text="Helpers.formatarValorMonetario(caracteristicas[coluna.valor] || 0)" />
                </template>
                <template v-else>
                  <p v-text="caracteristicas[coluna.valor] || '-'" />
                </template>

                <template v-if="coluna.icone">
                  <v-icon v-bind="coluna.icone.props">mdi-{{coluna.icone.icon}}</v-icon>
                </template>

                <span v-if="coluna.prefixo" class="ml-1">
                  {{coluna.prefixo}}
                </span>
              </div>
            </td>
          </tr>
        </table>
      </v-card-text>
    </v-dialog>
  </div>
</template>

<script>
import { buscarCaracteristicas } from '@/api/compras/MateriaPrima';
import { logout } from "@/helpers";

export default {
  name: "DetalhamentoCategoriaDialog",
  props: {
    detalhamento_categoria: Object
  },
  data: () => ({
    dialog_ativo: false,
    caracteristicas: {},
    linhas: [
      {
        colunas: [
          {descricao: 'Custo de Aquisição', valor: 'classificacao_financeira'},
          {descricao: 'Criticidade Resultado', valor: 'classificacao_criticidade'},
          {descricao: 'Comprabilidade', valor: 'classificacao_comprabilidade'},
          {descricao: 'Frequência Saída', valor: 'classificacao_popularidade', colspan: '3'},
        ]
      },
      {
        colunas: [
          {descricao: 'Nível de serviço', valor: 'nivel_servico'},
          {descricao: 'Perfil de Demanda', valor: 'perfil_demanda'},
          {descricao: 'Ressuprimento', valor: 'tempo_medio_ressuprimento', colspan: '3', numero: true, prefixo: 'dias'}
        ]
      },
      {
        colunas: [
          {descricao: 'Estoque', valor: 'estoque', numero: true},
          {descricao: 'Estoque de Segurança', valor: 'estoque_seguranca', numero: true},
          {descricao: 'Ponto de Pedido', valor: 'ponto_pedido', numero: true},
          {descricao: 'Estoque Máximo', valor: 'estoque_maximo', numero: true},
        ]
      },
      {
        colunas: [
          {descricao: 'Cobertura do estoque', valor: 'cobertura_estoque', numero: true, prefixo: 'dias'},
          {descricao: 'Cobertura do estoque de segurança', valor: 'cobertura_esseg_diaria', numero: true, prefixo: 'dias'},
          {descricao: 'Cobertura do ponto de pedido', valor: 'cobertura_pp_diaria', numero: true, prefixo: 'dias'},
          {descricao: 'Cobertura do estoque máximo', valor: 'cobertura_emax_diaria', numero: true, prefixo: 'dias'},
        ]
      },
      {
        colunas: [
          {descricao: 'Estoque Bloqueado', valor: 'estoque_bloqueado', numero: true},
          {descricao: 'Estoque Avaria', valor: 'estoque_avaria', numero: true},
          {descricao: 'Frequência Média de Apanhe', valor: 'tempo_medio_apanhe', numero: true},
          {
            descricao: 'Em trânsito',
            valor: 'compra_transito',
            style: 'color: #d60e2b;',
            icone: {
              icon: 'truck',
              props: {
                small: true,
                color: '#D60E2B',
                right: true
              }
            },
            numero: true
          },
        ]
      },
      {
        colunas: [
          {descricao: 'Projeção de vendas', valor: 'consumo_medio_mensal', numero: true},
          {descricao: 'Desvio Padrão Consumo', valor: 'desvio_padrao_consumo', numero: true},
          {descricao: 'Coeficiente Variação', valor: 'coeficiente_variacao', colspan: '3', numero: true, prefixo: '%'},
        ]
      }
    ]
  }),
  computed: {
    GRUPO_COMPRA() {
      return this.$store.getters['usuario/getGrupoCompras'];
    }
  },
  watch: {
    dialog_ativo(valor) {
      if (valor) {
        this.buscarDetalhamento();
      }
    }
  },
  methods: {
    buscarDetalhamento() {
      const parametros = {
        id_grupo: this.GRUPO_COMPRA,
        id_categoria: this.detalhamento_categoria.idcategoria,
      };

      this.$store.dispatch("loading/addRequisicao",
        buscarCaracteristicas(parametros)
          .then(caracteristicas => {
            this.caracteristicas = caracteristicas;
          })
          .catch(logout)
      );
    }
  }
}
</script>

<style scoped>
p {
  margin: 0;
  padding: 0;
}
table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}
table tr td {
  width: 20%;
  padding: 5px 5px;
}
table  tr:nth-child(even) {
  background: #FFFFFF
}
table  tr:nth-child(odd) {
  background: rgba(0,0,0,.04)
}
</style>
